import React from "react";
import { ShieldCheck, BadgeCheck, FileCheck, UserCheck } from "lucide-react";

const SIGNALS = [
  {
    icon: BadgeCheck,
    title: "Registered waste carriers only",
    body: "Carriers are checked against the official waste carrier register for their area.",
  },
  {
    icon: ShieldCheck,
    title: "£500 Flytipping Guarantee, subject to terms",
    body: "See our terms for what is covered.",
  },
  {
    icon: FileCheck,
    title: "Duty-of-care receipt",
    body: "A digital receipt for every job, generated automatically.",
  },
  {
    icon: UserCheck,
    title: "Carrier profiles",
    body: "Carrier profiles show their registration details.",
  },
];

export default function TrustStrip() {
  return (
    <section
      className="bg-moss-950 text-cream-50 py-14 md:py-16"
      data-testid="trust-strip"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {SIGNALS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="flex flex-col items-start"
                data-testid={`trust-item-${s.title.toLowerCase().split(" ").slice(0, 2).join("-")}`}
              >
                <div className="w-11 h-11 rounded-xl bg-sage-500/15 border border-sage-400/25 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-sage-300" strokeWidth={2.25} />
                </div>
                <p className="mt-4 text-sm sm:text-base font-semibold text-cream-50 leading-tight">
                  {s.title}
                </p>
                <p className="mt-2 text-xs sm:text-sm text-cream-100/60 leading-relaxed">
                  {s.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
